import { LegalLayout } from "@/pages/LegalLayout";

export default function TermsPage() {
  return (
    <LegalLayout title="Terms of Service">
      <div>
        <h2 className="font-display text-xl font-bold text-white mb-3">1. Services</h2>
        <p>
          All In Hand Marketing provides strategy, branding, digital marketing, automation,
          technology, and consulting services as described on our offer pages and, for custom
          engagements, in an individual proposal or agreement.
        </p>
      </div>
      <div>
        <h2 className="font-display text-xl font-bold text-white mb-3">2. Orders &amp; Payment</h2>
        <p>
          One-time purchases, such as the Digital Snapshot and Business Growth Assessment, are
          processed securely through Stripe at checkout. Ongoing or custom engagements are scoped in
          writing, with pricing and deliverables agreed before work begins.
        </p>
      </div>
      <div>
        <h2 className="font-display text-xl font-bold text-white mb-3">3. No Guaranteed Results</h2>
        <p>
          No ethical marketing provider can guarantee a specific search ranking, number of leads,
          revenue amount, or business result. Performance depends on numerous factors outside any
          agency's control. We focus on agreed deliverables, sound marketing practices, measurement,
          testing, and continuous improvement. Past results, examples, projections, or estimates do
          not guarantee future outcomes.
        </p>
      </div>
      <div>
        <h2 className="font-display text-xl font-bold text-white mb-3">4. Your Responsibilities</h2>
        <p>
          Customers remain responsible for their business decisions, regulatory obligations, accounts,
          advertising budgets, and approval of final materials.
        </p>
      </div>
      <div>
        <h2 className="font-display text-xl font-bold text-white mb-3">5. Guarantee &amp; Refunds</h2>
        <p>
          Purchases identified as guarantee-eligible at checkout are covered by our 7-Day Money-Back
          Guarantee. See the complete Refund Policy for conditions and exclusions.
        </p>
      </div>
      <div>
        <h2 className="font-display text-xl font-bold text-white mb-3">6. Intellectual Property</h2>
        <p>
          Assessment reports, templates, creative work, and systems delivered by All In Hand Marketing
          are protected work product. Usage rights for deliverables are defined in the applicable
          proposal or agreement.
        </p>
      </div>
      <div>
        <h2 className="font-display text-xl font-bold text-white mb-3">7. Changes to These Terms</h2>
        <p>
          These terms may be updated from time to time. The version in effect at the time of your
          purchase applies to that transaction. Contact:{" "}
          <a href="mailto:allinhand@zohomail.com" data-testid="terms-contact-email" className="text-gold underline underline-offset-2">
            allinhand@zohomail.com
          </a>
          .
        </p>
      </div>
    </LegalLayout>
  );
}
